"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowsePlacement = void 0;
var BrowsePlacement;
(function (BrowsePlacement) {
    BrowsePlacement["TagSearch"] = "tag_search";
})(BrowsePlacement = exports.BrowsePlacement || (exports.BrowsePlacement = {}));
